import { atomicColor } from '@df/ui/atomic/atomic-options';
import { NICmsClientConfig } from '@icms/client/config/icms-client.config';
import range from 'lodash-es/range';

export const defaultImage = '/cms/media/default.svg';
export const routeError = '_routeError';

export const ICMS_CONFIG: NICmsClientConfig.IConfig = {
    modules: {
        campaigns: {
            enabled: true
        },
        templates: {
            enabled: true
        }
        // merchandiser: {
        //     enabled: true,
        //     indicatorShift: ['20px', '20px', '20px', '20px']
        // }
    },
    sizes: [
        {
            id: 'X',
            label: 'Large Desktop',
            width: 1920
        },
        {
            id: 'L',
            label: 'Desktop',
            width: 1440,
            default: true
        },
        {
            id: 'M',
            label: 'Tablet',
            width: 773, // 768 + 15px scrollbar padding
            height: 1024
        },
        {
            id: 'S',
            label: 'Mobile',
            width: 400, // 375 + 15px scrollbar padding
            height: 667
        }
    ],
    colors: atomicColor as NICmsClientConfig.IColorConfig[],
    spacings: range(0, 21).map(key => ({ key: `${key * 4}px`, title: `${key} (${key * 4}px)` })),
    resourcesMockup: {
        page: [
            {
                id: -100,
                type: 'page',
                store: 1,
                url: '/default-blog-category',
                name: 'Default blog category',
                typeData: {
                    tagRedirect: true,
                    topCopy: 'Latest news'
                },
                pageType: 'blog-root',
                position: 624,
                _cms: {
                    absoluteUrl: true,
                    status: 1,
                    url: '/default-blog-category'
                },
                verbosity: 4
            },
            {
                id: -101,
                type: 'page',
                store: 1,
                url: '/default-blog',
                breadcrumbs: [
                    {
                        label: 'Blog Category',
                        url: '/default-blog-category'
                    }
                ],
                name: 'Default blog post',
                parent: -100,
                image: '/cms/media/default.svg',
                typeData: {
                    readingTime: '3m',
                    ratio: 'ratio-3-1',
                    author: 'Jane',
                    date: '2022-08-21T22:00:00.000Z',
                    tags: [-100]
                },
                pageType: 'blog-post',
                position: 10,
                _cms: {
                    absoluteUrl: false,
                    status: 1,
                    slug: 'post-16',
                    url: '/default-blog-category/default-blog'
                },
                verbosity: 4
            }
        ],
        product: [
            {
                url: '/example-product',
                id: -100,
                sku: 'example-product',
                name: 'Example product',
                visibility: {
                    catalog: true,
                    search: true
                },
                image: defaultImage,
                price: 129,
                verbosity: 2,
                category_path: 'Category Name',
                size: 8,
                color: 5,
                type: 'product'
            },
            {
                url: '/example-product',
                id: -101,
                sku: 'example-product',
                name: 'Example product 1',
                visibility: {
                    catalog: true,
                    search: true
                },
                image: defaultImage,
                price: 120,
                verbosity: 2,
                category_path: 'Category Name',
                size: 8,
                color: 5,
                type: 'product'
            },
            {
                url: '/example-product',
                id: -102,
                sku: 'example-product',
                name: 'Example product 2',
                visibility: {
                    catalog: true,
                    search: true
                },
                image: defaultImage,
                price: 110,
                verbosity: 2,
                category_path: 'Category Name',
                size: 8,
                color: 5,
                type: 'product'
            },
            {
                url: '/example-product',
                id: -103,
                sku: 'example-product',
                name: 'Example product 3',
                visibility: {
                    catalog: true,
                    search: true
                },
                image: defaultImage,
                price: 100,
                orgPrice: 120,
                verbosity: 2,
                category_path: 'Category Name',
                size: 8,
                color: 5,
                type: 'product'
            },
            {
                url: '/example-product',
                id: -104,
                sku: 'example-product',
                name: 'Example product 4',
                visibility: {
                    catalog: true,
                    search: true
                },
                image: defaultImage,
                price: 130,
                verbosity: 2,
                category_path: 'Category Name',
                size: 8,
                color: 5,
                type: 'product'
            }
        ]
    }
};
